import { Col, Menu, Row, theme } from 'antd';
import { Route, Routes, matchRoutes, useLocation, useResolvedPath } from 'react-router-dom';

export interface RouteDefinition {
  id: string;
  path: string;
  element: React.ReactNode;
}

interface MenuItemDefinition {
  key: string;
  label: JSX.Element;
  style?: React.CSSProperties;
}

interface HorizontalTabsProps {
  routes: RouteDefinition[];
  menuItems: MenuItemDefinition[];
}

export const HorizontalTabs: React.FC<HorizontalTabsProps> = ({ routes, menuItems }) => {
  const displayMenu = !!(menuItems.length > 1);
  const currentRoutePath = useResolvedPath('').pathname;

  const location = useLocation();
  const matchedPages = matchRoutes(
    routes.map((r) => {
      return {
        id: r.id,
        path: `${currentRoutePath}/${r.path}`
      };
    }),
    location
  );
  const matchedIds = matchedPages ? matchedPages.map((x: any) => x.route.id.toString()) : [];

  const {
    token: { colorTextBase }
  } = theme.useToken();

  return (
    <Row style={{ color: colorTextBase }}>
      {displayMenu && (
        <Col span={24}>
          <Menu
            mode="horizontal"
            selectedKeys={matchedIds}
            style={{
              width: '100%',
              marginTop: '60px',
              paddingBottom: '15px',
              backgroundColor: 'transparent',
              
            }}
            items={menuItems.map((item) => ({
              ...item,
              style: { flex: 'none' }, 
            }))}
          />
        </Col>
      )}
      <Col span={24} style={{}}>   
        <Routes>
          {routes.map((route) => (
            <Route key={route.id} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Col>
    </Row>
  );
};
